import { useState } from 'react'
import { Box, Button, Flex } from '@chakra-ui/react'
import { AddTime } from './AddTime'

const formSchedulePoint = (day, time, tz) => ({
    "day": day,
    "time": time,
    "zoneId": tz
})

export const NewInterval = ({ onAddInterval }) => {
    const [startTime, setStartTime] = useState(null)
    const [stopTime, setStopTime] = useState(null)
    const [showSetTimeBlock, setShowSetTimeBlock] = useState(false)
    const [editableField, setEditableField] = useState(null)

    const handleTimeChange = (type, value) => {
        if (type === 'start') {
            setStartTime(value)
        } else if (type === 'stop') {
            setStopTime(value)
        }
        setShowSetTimeBlock(false)
    }

    const handleAddInterval = () => {
        const [sDay, sTime, sTz] = startTime.split(' ')
        const [eDay, eTime, eTz] = stopTime.split(' ')

        const boilerplate = [
            formSchedulePoint(sDay, sTime, sTz),
            formSchedulePoint(eDay, eTime, eTz)
        ]
        onAddInterval(boilerplate)
    }

    return (
        <Box w="100%">
            {showSetTimeBlock ? (
                <Box>
                    <AddTime
                        type={editableField}
                        startTime={startTime}
                        endTime={stopTime}
                        onTimeChange={handleTimeChange}
                    />
                </Box>
            ) : (
                <>
                    <Flex justifyContent="space-around" w="100%">
                        <Box>
                            <Box mb={2} textAlign="center">
                                Start
                            </Box>
                            <Box>
                                {startTime || (
                                    <Button
                                        onClick={() => {
                                            setEditableField('start')
                                            setShowSetTimeBlock(true)
                                        }}
                                    >
                                        ADD
                                    </Button>
                                )}
                            </Box>
                        </Box>
                        <Box>
                            <Box mb={2} textAlign="center">
                                Stop
                            </Box>
                            <Box>
                                {stopTime || (
                                    <Button
                                        onClick={() => {
                                            setEditableField('stop')
                                            setShowSetTimeBlock(true)
                                        }}
                                    >
                                        ADD
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Flex>
                    <Button 
                        mx='auto'
                        marginTop={3}
                        display="flex"
                        onClick={handleAddInterval}
                        isDisabled={!startTime || !stopTime}
                    >
                        Add Interval
                    </Button>
                </>
            )}
        </Box>
    )
}
